<glxy-empty-state [size]="size">
  <glxy-empty-state-hero>
    <mat-icon class="larger-icon">{{ icon }}</mat-icon>
  </glxy-empty-state-hero>
  <glxy-empty-state-title>{{ title | translate }}</glxy-empty-state-title>
  <p>{{ subtitle | translate }}</p>
</glxy-empty-state>
